export const handleSearchSRfun = async (searchCANId, searchSR) => {
    const url = process.env.REACT_APP_API_URL;
    const data = {
        "Action": "getSRStatusIVR",
        "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
        "CANID": searchCANId,
        "SRNo": searchSR
      };
    const response = await fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    });
    const result = await response.json();
    return result;
}


export const handleSearchByCanId = async (searchCANId) => {
    const url = process.env.REACT_APP_API_URL;
    const data = {
        Action: 'getAccountDataIVR',
        Authkey: 'ac7b51de9d888e1458dd53d8aJAN3ba6f',
        CANID: searchCANId,
        Phone: "",
      };
    const response = await fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    });
    const result = await response.json();
    return result;
}

